import { createEmptyCollection } from 'helpers/normalizeHelpers'
import { Reducer } from 'interfaces'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { GetCCStateAction } from 'components/features/creditCard/creditCardStore/actions'

const INITIAL_STATE = createEmptyCollection()
export const ccLedgersReducer: Reducer<CreditCardDataState['ledgers']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetCCStateAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      const { ledgers } = action.payload.response
      return ledgers
    }
  }
  return prevState
}
